import { render, staticRenderFns } from "./m-help-banner.vue?vue&type=template&id=2ad6ef74&scoped=true&"
import script from "./m-help-banner.vue?vue&type=script&lang=js&"
export * from "./m-help-banner.vue?vue&type=script&lang=js&"
import style0 from "./m-help-banner.vue?vue&type=style&index=0&id=2ad6ef74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad6ef74",
  null
  
)

export default component.exports